<template lang="pug">
  .product-container
    .product-header
      .product-title Libra - KOL投放分析工具
      .product-desc {{ $t('Libra是一款专为市场策划人员设计的KOL投前分析工具。深受雅诗兰黛、兰蔻、百雀羚等美妆大厂的青睐。累积20,000+KOL服务及效果数据，覆盖60+MCN报价信息，支持指定品牌数据回采。') }}
      el-button.product-link(
        @click="onApplyAccount"
      ) {{ $t('申请Demo账号') }}
      .product-img
        img(
          src="@/assets/ktb-1.png"
        )
    .product-content-container
      .product-content-item(style="margin-bottom: 0")
        img(
          src="@/assets/ktb-2.png"
        )
        .product-content-desc.product-content-desc__ml
          .desc-title(style="padding-left: 26px") {{ $t('方法') }}
          .desc {{ $t('Libra通过关键词库对不同渠道的KOL发文内容进行抓取。展现品牌主真实KOL投放效果，并对各品牌每月KOL花费进行合理估算。') }}
      .product-content-item(style="margin-bottom: 0;align-items: flex-start")
        .product-content-desc.product-content-desc__ml
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('品牌关键词库') }}
          .desc(style="width: 470px;") {{ $t('经过多年搜索营销领域的开发经验，我们累积了不同行业不同产品线的关键词库，方便覆盖品牌对应KOL发文内容。') }}
        .product-content-desc.product-content-desc__ml
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('KOL发文库') }}
          .desc(style="width: 470px;") {{ $t('通过自有爬虫及数据合作伙伴对微信、微博、小红书渠道中的KOL发文内容进行抓取，在保留原文内容的同时，更抓取了发文对应表现数据，以方便用户对KOL投放效果进行衡量。抖音、快手等热门渠道也在着力开发中，会在新的迭代版本中陆续上线。') }}
      .product-content-item
        .product-content-desc.product-content-desc__ml
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('KOL报价库') }}
          .desc(style="width: 470px;") {{ $t('已与60+头部MCN建立联系，定期更新最新KOL报价信息及服务方式，我们已将这部分信息以数据形式搭建成库，方便广告主对竞品品牌花费进行参考。') }}
      .product-content-item
        .product-content-desc.product-content-desc__mr
          .desc-title(style="padding-left: 26px") {{ $t('洞察') }}
          .desc
            p {{ $t('通过Libra的数据积累，我们还可以根据品牌主要求输出指定品牌报告。') }}
            p {{ $t('以下为某国内知名美妆品牌2019年KOL投放报告样例：') }}
          .desc_btn(@click="getReport") {{ $t('获取报告') }}
        img(
          src="@/assets/ktb-3.png"
          )
    section#clients-say
      div.clients-say__content
        img(
          alt="what our clients say"
          src="@/assets/clients-say-logo.png"
        )
        div
          .client-name Lean Zhang
            span 百雀羚 品牌负责人
          ul.clients-say__case__content
            li(:class="{'active': activeIndex === 0}")
              p {{ $t('作为品牌的主理人，许多同业友商的KOL投放策略都是非常值得我们去深入研究。但海量的大数据的收集&整理、研究&分析不仅要依赖高度的专业性，同时也需花费相当大的时间和人力。Libra的定向报告服务很好的帮我们解决了这个问题，只需指定好目标的品牌、渠道、以及数据回溯的时间段，就可以按需输出该品牌投放策略的数据和内容信息。同步结合运营人员的分析报告，就可以更便捷地了解到各友商品牌的social-mkt策略。另外，分析报告中还会就不同粉丝量级评选出高性价比的KOL，作为品牌之后投放策略的判断依据标准之一。') }}
    contact
</template>

<script>
import PageFooter from '@/components/PageFooter'
import Contact from '@/components/Contact'
export default {
  components: {
    PageFooter,
    Contact
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  methods: {
    onApplyAccount () {
      this.$router.push('/contact?redirectUrl=/product/libra&buttonName=申请Demo账号')
    },
    getReport () {
      this.$router.push('/contact?redirectUrl=/product/libra&buttonName=获取报告')
    }
  }
}
</script>
